import { getHtmlTelLink } from '../../../../utils/link'
import { EntityLink } from '../../../Entity'
import { TableCellBase } from '../TableCellBase'
import { TableEmptyCell } from '../TableEmptyCell'

function TablePhoneCell({ tooltip, value, ...cellProps }) {
  return value ? (
    <TableCellBase {...cellProps}>
      <EntityLink text={value} to={getHtmlTelLink(value)} tooltip={tooltip} />
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} />
  )
}

export default TablePhoneCell
